import CreateDiagnosticObjectivePiece from "./CreateDiagnosticObjectivePiece";
import { formatCurrency } from "@/common/utils/formatters";
import { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { MaintenanceDirectiveObjectiveData } from "@/features/maintenance/features/workflows/types/forwardings/directiveEntries/directiveEntry.type";
import DiagnosticObjectivePieceItem from "./DiagnosticObjectivePieceItem";

interface DiagnosticEntryUpdateObjectiveAttributesDiagnosticObjectivePiecesProps {
  diagnosticObjective: MaintenanceDirectiveObjectiveData;
}

const DiagnosticEntryUpdateObjectiveAttributesDiagnosticObjectivePieces = ({
  diagnosticObjective,
}: DiagnosticEntryUpdateObjectiveAttributesDiagnosticObjectivePiecesProps) => {
  const { workflowId, forwardingId } = useParams();

  const queryClient = useQueryClient();

  const forwardingState = queryClient.getQueryState(['maintenanceForwarding', forwardingId]);

  const piecesCountDisplay = useMemo(() => {
    const count = diagnosticObjective.diagnostic_pieces?.length || 0;

    if (count === 0) {
      return 'Nenhuma peça';
    }

    if (count === 1) {
      return '1 Peça';
    }

    return `${count} Peças`;
  }, [forwardingState?.dataUpdatedAt]);

  const totalValueSum = useMemo(() => {
    return diagnosticObjective.diagnostic_pieces?.reduce((prev, curr) => {
      return prev + Number(curr.total_value);
    }, 0) || 0;
  }, [forwardingState?.dataUpdatedAt]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex flex-col">
          <p className="font-bold text-base">
            Peças
          </p>

          <div className="flex items-center gap-0.5 text-xs">
            <span>
              {piecesCountDisplay}
            </span>

            <span>
              •
            </span>

            <span className="text-valid">
              {formatCurrency(totalValueSum)}
            </span>
          </div>
        </div>

        <CreateDiagnosticObjectivePiece
          diagnosticObjectiveId={diagnosticObjective.id}
          diagnosticObjectivePartId={diagnosticObjective.part?.id}
          selectedPiecesIds={diagnosticObjective.diagnostic_pieces?.map((diagnosticPiece) => diagnosticPiece.piece.id) || []}
        />
      </div>

      <div className="flex flex-col gap-3">
        {diagnosticObjective.diagnostic_pieces?.map((diagnosticPiece) => (
          <DiagnosticObjectivePieceItem
            key={diagnosticPiece.id}
            workflowId={workflowId}
            diagnosticPiece={diagnosticPiece}
          />
        ))}
      </div>
    </div>
  );
}

export default DiagnosticEntryUpdateObjectiveAttributesDiagnosticObjectivePieces;
